import {AccountTypeT} from '@/lib/types/authentication.types';
import {FormFieldT, FormStepT} from '@/lib/types/form.types';

import BrandTerms from '@/lib/forms/components/BrandTerms';
import DistributorTerms from '@/lib/forms/components/DistributorTerms';
import RetailerTerms from '@/lib/forms/components/RetailerTerms';
import SpeculatorTerms from '@/lib/forms/components/SpeculatorTerms';

/****************************************************************************
 * Form Fields
 ****************************************************************************/
export const termsFormFields: FormFieldT[] = [
  {
    name: 'speculator_terms',
    custom: true,
    type: 'static',
    content: <SpeculatorTerms />,
    options: {
      validate: () => false,
    },
  },
  {
    name: 'brand_terms',
    custom: true,
    type: 'static',
    content: <BrandTerms />,
    options: {
      validate: () => false,
    },
  },
  {
    name: 'retailer_terms',
    custom: true,
    type: 'static',
    content: <RetailerTerms />,
    options: {
      validate: () => false,
    },
  },
  {
    name: 'distributor_terms',
    custom: true,
    type: 'static',
    content: <DistributorTerms />,
    options: {
      validate: () => false,
    },
  },
  {
    label: 'I agree to all Terms & Conditions',
    name: 'terms_accepted',
    type: 'checkbox',
    custom: true,
    options: {
      required: 'You must agree to all Terms & Conditions',
    },
  },
];

/****************************************************************************
 * Form Fields Generator
 ****************************************************************************/
export const getTermsFormFields = (accountType: AccountTypeT = 'speculator', excludeSpeculator: boolean = false) => {
  // Typeguard to ensure accountType is valid
  if (!['brand', 'retailer', 'distributor', 'speculator'].includes(accountType)) {
    throw new Error(`Invalid account type: ${accountType}`);
  }

  // Start with the speculator terms if excludeSpeculator is false
  const fields: FormFieldT[] = excludeSpeculator
    ? []
    : [...termsFormFields.filter(field => field.name === 'speculator_terms')];

  // Add additional terms based on account type
  if (accountType !== 'speculator') {
    fields.push(termsFormFields.find(field => field.name === `${accountType.toLowerCase()}_terms`)!);
  }

  // Agreement checkbox is always last
  fields.push(...termsFormFields.filter(field => field.name === 'terms_accepted'));

  return fields;
};

/****************************************************************************
 * Form Steps
 ****************************************************************************/
export type TermsFieldNamesT =
  | 'speculator_terms'
  | 'brand_terms'
  | 'retailer_terms'
  | 'distributor_terms'
  | 'terms_accepted';

export const termsFormSteps: FormStepT<TermsFieldNamesT> = [
  {
    step: 0,
    label: 'Terms & Conditions',
    fields: ['speculator_terms', 'brand_terms', 'retailer_terms', 'distributor_terms', 'terms_accepted'],
  },
];
